export const getRegionByTimezone = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(tz)
  if (tz === 'Asia/Qatar') return 'QA';
  if (tz === 'Asia/Dubai') return 'AE';
  if (tz === 'Asia/Calcutta') return 'IN';
  
  return 'UNKNOWN';
};